__turbopack_context__.v({
  "Actions": "t64fvW_Actions",
  "AddAnnotationButton": "t64fvW_AddAnnotationButton",
  "AnnotationActions": "t64fvW_AnnotationActions",
  "AnnotationCoord": "t64fvW_AnnotationCoord",
  "AnnotationInfo": "t64fvW_AnnotationInfo",
  "AnnotationItem": "t64fvW_AnnotationItem",
  "AnnotationItems": "t64fvW_AnnotationItems",
  "AnnotationText": "t64fvW_AnnotationText",
  "CancelButton": "t64fvW_CancelButton",
  "CloseButton": "t64fvW_CloseButton",
  "EmptyText": "t64fvW_EmptyText",
  "Field": "t64fvW_Field",
  "FieldRow": "t64fvW_FieldRow",
  "Form": "t64fvW_Form",
  "Header": "t64fvW_Header",
  "HelpText": "t64fvW_HelpText",
  "IconButton": "t64fvW_IconButton",
  "Input": "t64fvW_Input",
  "Label": "t64fvW_Label",
  "ListRoot": "t64fvW_ListRoot",
  "Modal": "t64fvW_Modal",
  "Overlay": "t64fvW_Overlay",
  "Required": "t64fvW_Required",
  "SaveButton": "t64fvW_SaveButton",
  "Select": "t64fvW_Select",
  "Title": "t64fvW_Title",
  "skeleton-loading": "t64fvW_skeleton-loading",
});
